<template>
  <ul class="vx-timeline">
    <li v-for="item in data" :key="item.id">
      <div class="flex justify-between items-center">
        <div>
          <div class="timeline-icon rounded px-2 w-16 text-center" :class="`bg-${item.color}`">
            <vx-tooltip :text="item.id" position="right">
              <h6 class="text-white truncate">{{ item.id }}</h6>
            </vx-tooltip>
          </div>
          <div class="timeline-info">
            <p class="font-semibold" >{{item.title}}</p>
            <span class="activity-desc" ><b>{{item.condition}}: </b><i>{{item.desc}}</i></span>
          </div>
        </div>
        <div>
          <vs-button radius color="danger" type="border" icon-pack="feather" icon="icon-x" @click="item.remove(item.id)"></vs-button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "vx-timeline",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
